import { Injectable } from '@angular/core';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root',
})
export class SideBarService {
  constructor(private _commonService: CommonService) {}

  generateSidebar(validRoute: any) {
    return [
      {
        name: 'Dashboard',
        icon: '../../../../assets/images/dashboard_icon.png',
        routerLink: '/dashboard',
        userRole: ['user', 'SuperAdmin', 'Admin'],
        isVisible: true,
      },
      {
        name: 'Settings',
        icon: '../../../../assets/images/dashboard_icon.png',
        userRole: ['SuperAdmin', 'Admin'],
        isToggleMenu: true, // Indicates this menu has submenus
        subMenuVisible: false,
        isVisible:
          this._commonService.getRole() == 'SuperAdmin' ||
          this._commonService.getRole() == 'Admin'
            ? true
            : false,
        subMenu: [
          {
            name: 'Organization Setup',
            icon: '',
            routerLink: '/setup',
            userRole: ['SuperAdmin', 'Admin'],
            isChild: ['office/create', 'office/edit'],
            isVisible: true,
          },
          {
            name: 'User Management',
            icon: '',
            routerLink: '/user-management',
            userRole: ['SuperAdmin', 'Admin'],
            isVisible: true,
          },
          {
            name: 'Reminder Settings',
            icon: '',
            routerLink: '404',
            userRole: ['SuperAdmin', 'Admin'],
            // isVisible: true,
            isVisible: false,
          },
          {
            name: 'Access Management',
            icon: '',
            routerLink: '/access-management',
            userRole: ['SuperAdmin', 'Admin'],
            isVisible: true,
          },
          {
            name: 'System Configuration',
            icon: '',
            routerLink: '/admin-configuration',
            userRole: ['Admin'],
            isVisible: this._commonService.getRole() == 'Admin' ? true : false,
          },
          {
            name: 'Email Requests',
            icon: '',
            routerLink: '/email-requests',
            userRole: ['Admin'],
            isVisible: this._commonService.getRole() == 'Admin' ? true : false,
          },
        ],
      },
      {
        name: 'Environment',
        icon: '../../../../assets/images/dashboard_icon.png',
        routerLink: '/environment',
        userRole: ['user', 'Admin', 'SuperAdmin'],
        isToggleMenu: true, // Indicates this menu has submenus
        subMenuVisible: false,
        isVisible: true
          ? validRoute?.findIndex((permission: any) =>
              [
                'inventorization',
                'ghg emission',
                'goal setting and tracking',
                'ghg avoidance and removal strategy',
                'avoidance- oil and gas',
                'Water Management',
                'Waste Management',
                'Biodiversity & Eco System',
                'Energy Management',
                'Health and safety',
              ].includes(permission.moduleName?.toLowerCase())
            ) > -1 &&
            validRoute?.some(
              (permission: any) =>
                [
                  'inventorization',
                  'ghg emission',
                  'goal setting and tracking',
                  'ghg avoidance and removal strategy',
                  'avoidance- oil and gas',
                  'Water Management',
                  'Waste Management',
                  'Biodiversity & Eco System',
                  'Energy Management',
                ].includes(permission.moduleName?.toLowerCase()) &&
                permission.isActive === true
            )
          : false,
        subMenu: [
          {
            name: 'GHG Suite', // Parent menu item for GHG Suite
            icon: '../../../../assets/images/GHG_emission_icon.png',
            userRole: ['user', 'Admin', 'SuperAdmin'],
            isToggleMenu: true, // Indicates this menu has submenus
            subMenuVisible: false, // Submenu is initially hidden
            isVisible: true
              ? validRoute?.findIndex((permission: any) =>
                  [
                    'inventorization',
                    'ghg emission',
                    'goal setting and tracking',
                    'ghg avoidance and removal strategy',
                    'avoidance- oil and gas',
                  ].includes(permission.moduleName?.toLowerCase())
                ) > -1 &&
                validRoute?.some(
                  (permission: any) =>
                    [
                      'inventorization',
                      'ghg emission',
                      'goal setting and tracking',
                      'ghg avoidance and removal strategy',
                      'avoidance- oil and gas',
                    ].includes(permission.moduleName?.toLowerCase()) &&
                    permission.isActive === true
                )
              : false,
            nestedSubMenu: [
              {
                name: 'Inventorization',
                icon: '../../../../assets/images/Inventory_Blue1.png',
                icon2: '../../../../assets/images/Inventory_White1.png',
                routerLink: '/environment/ghgSuite/Inventorization',
                userRole: ['user', 'Admin', 'SuperAdmin'],
                isVisible:
                  validRoute?.findIndex(
                    (permission: any) =>
                      permission.moduleName?.toLowerCase() ==
                      'Inventorization'.toLowerCase()
                  ) > -1 &&
                  validRoute[
                    validRoute?.findIndex(
                      (permission: any) =>
                        permission.moduleName?.toLowerCase() ==
                        'Inventorization'.toLowerCase()
                    )
                  ].isActive
                    ? true
                    : false,
              },
              {
                name: 'GHG Emission',
                icon: '../../../../assets/images/GHG_Emission_Blue1.png',
                icon2: '../../../../assets/images/GHG_Emission_White1.png',
                routerLink: '/environment/ghgSuite/GHG_Emission',
                userRole: ['user', 'Admin', 'SuperAdmin'],
                // isChild: ['/GHG_Emission'],
                isVisible: true
                  ? validRoute?.findIndex(
                      (permission: any) =>
                        permission.moduleName.toLowerCase() ==
                        'GHG Emission'.toLowerCase()
                    ) > -1 &&
                    validRoute[
                      validRoute?.findIndex(
                        (permission: any) =>
                          permission.moduleName?.toLowerCase() ==
                          'GHG Emission'.toLowerCase()
                      )
                    ]?.isActive
                  : false,
              },
              {
                name: 'Goal Setting and Tracking',
                icon: '../../../../assets/images/Goal Setting & Tracking.png',
                icon2:
                  '../../../../assets/images/Goal Setting & Tracking_white.png',
                routerLink: '/environment/ghgSuite/offset-strategy',
                userRole: ['user', 'Admin', 'SuperAdmin'],
                isChild: ['/environment/ghgSuite/offset-strategy/:id'],
                isVisible: true
                  ? validRoute?.findIndex(
                      (permission: any) =>
                        permission.moduleName.toLowerCase() ==
                        'Goal Setting and Tracking'.toLowerCase()
                    ) > -1 &&
                    validRoute[
                      validRoute?.findIndex(
                        (permission: any) =>
                          permission?.moduleName?.toLowerCase() ==
                          'Goal Setting and Tracking'.toLowerCase()
                      )
                    ]?.isActive
                  : false,
              },
              {
                name: 'Avoidance and Removal Strategy',
                icon: '../../../../assets/images/Avoidance & Removal Strategy.png',
                icon2:
                  '../../../../assets/images/Avoidance & Removal Strategy_white.png',
                routerLink:
                  '/environment/ghgSuite/GHGAvoidanceAndRemovalStrategyIdentification',
                userRole: ['user', 'Admin', 'SuperAdmin'],
                isVisible: true
                  ? validRoute?.findIndex(
                      (permission: any) =>
                        permission.moduleName?.toLowerCase() ==
                        'Avoidance And Removal Strategy'.toLowerCase()
                    ) > -1 &&
                    validRoute[
                      validRoute?.findIndex(
                        (permission: any) =>
                          permission.moduleName?.toLowerCase() ==
                          'Avoidance And Removal Strategy'.toLowerCase()
                      )
                    ].isActive
                  : false,
              },
              {
                name: 'Avoidance - Oil and Gas',
                icon: '../../../../assets/images/GHG Avoidance and carbon Offsetting.png',
                icon2:
                  '../../../../assets/images/GHG Avoidance and carbon Offsetting_white.png',
                routerLink: '/environment/ghgSuite/ghg-avoidance',
                userRole: ['user', 'Admin', 'SuperAdmin'],
                isVisible: true
                  ? validRoute?.findIndex(
                      (permission: any) =>
                        permission.moduleName.toLowerCase() ==
                        'Avoidance- Oil and Gas'.toLowerCase()
                    ) > -1 &&
                    validRoute[
                      validRoute?.findIndex(
                        (permission: any) =>
                          permission.moduleName.toLowerCase() ==
                          'Avoidance- Oil and Gas'.toLowerCase()
                      )
                    ].isActive
                  : false,
                // isVisible: true,
              },
            ],
          },
          {
            name: 'Water Management',
            icon: '../../../../assets/images/Water Management-1.png',
            icon2: '../../../../assets/images/Water Management.png',
            routerLink: '/environment/water-management',
            userRole: ['user', 'Admin', 'SuperAdmin'],
            // isChild: ['/water-management'],
            isVisible:
              validRoute?.findIndex(
                (permission: any) =>
                  permission.moduleName?.toLowerCase() ==
                  'Water Management'.toLowerCase()
              ) > -1 &&
              validRoute[
                validRoute?.findIndex(
                  (permission: any) =>
                    permission.moduleName?.toLowerCase() ==
                    'Water Management'.toLowerCase()
                )
              ].isActive
                ? true
                : false,
          },
          {
            name: 'Waste Management',
            icon: '../../../../assets/images/Waste Management-1.png',
            icon2: '../../../../assets/images/Waste Management.png',
            routerLink: '/environment/waste-management',
            userRole: ['user', 'Admin', 'SuperAdmin'],
            // isChild: ['/waste-management'],
            isVisible:
              validRoute?.findIndex(
                (permission: any) =>
                  permission.moduleName?.toLowerCase() ==
                  'Waste Management'.toLowerCase()
              ) > -1 &&
              validRoute[
                validRoute?.findIndex(
                  (permission: any) =>
                    permission.moduleName?.toLowerCase() ==
                    'Waste Management'.toLowerCase()
                )
              ].isActive
                ? true
                : false,
          },
          {
            name: 'Biodiversity & Eco System',
            icon: '../../../../assets/images/Biodiversity-1.png',
            icon2: '../../../../assets/images/Biodiversity.png',
            routerLink: '/environment/biodiversity',
            userRole: ['user', 'Admin', 'SuperAdmin'],
            // isChild: ['/biodiversity'],
            isVisible:
              validRoute?.findIndex(
                (permission: any) =>
                  permission.moduleName?.toLowerCase() ==
                  'Biodiversity & Eco System'.toLowerCase()
              ) > -1 &&
              validRoute[
                validRoute?.findIndex(
                  (permission: any) =>
                    permission.moduleName?.toLowerCase() ==
                    'Biodiversity & Eco System'.toLowerCase()
                )
              ].isActive
                ? true
                : false,
          },
          {
            name: 'Energy Management',
            icon: '../../../../assets/images/Biodiversity-1.png',
            icon2: '../../../../assets/images/Biodiversity.png',
            routerLink: '/environment/energy-management',
            userRole: ['user', 'Admin', 'SuperAdmin'],
            isVisible:
              validRoute?.findIndex(
                (permission: any) =>
                  permission.moduleName?.toLowerCase() ==
                  'Energy Management'.toLowerCase()
              ) > -1 &&
              validRoute[
                validRoute?.findIndex(
                  (permission: any) =>
                    permission.moduleName?.toLowerCase() ==
                    'Energy Management'.toLowerCase()
                )
              ].isActive
                ? true
                : false,
          },
          {
            name: 'Pollution',
            icon: '../../../../assets/images/Biodiversity-1.png',
            icon2: '../../../../assets/images/Biodiversity.png',
            routerLink: '/environment/pollution',
            userRole: ['user', 'Admin', 'SuperAdmin'],
            isVisible:
              validRoute?.findIndex(
                (permission: any) =>
                  permission.moduleName?.toLowerCase() ==
                  'Pollution'.toLowerCase()
              ) > -1 &&
              validRoute[
                validRoute?.findIndex(
                  (permission: any) =>
                    permission.moduleName?.toLowerCase() ==
                    'Pollution'.toLowerCase()
                )
              ].isActive
                ? true
                : false,
          },
        ],
      },
      {
        name: 'Social',
        icon: '../../../../assets/images/dashboard_icon.png',
        userRole: ['user', 'Admin', 'SuperAdmin'],
        isToggleMenu: true, // Indicates this menu has submenus
        subMenuVisible: false,
        isVisible: true
          ? validRoute?.findIndex((permission: any) =>
              [
                'ohs',
                'community engagement',
                'employee details',
                'training & development',
                'employee satisfaction & retention',
              ].includes(permission.moduleName?.toLowerCase())
            ) > -1 &&
            validRoute?.some(
              (permission: any) =>
                [
                  'ohs',
                  'community engagement',
                  'employee details',
                  'training & development',
                  'employee satisfaction & retention',
                ].includes(permission.moduleName?.toLowerCase()) &&
                permission.isActive === true
            )
          : false,
        subMenu: [
          {
            name: 'CSR & Community Engagement',
            icon: '../../../../assets/images/environment.png',
            icon2: '../../../../assets/images/environment-1.png',
            routerLink: '/social/community-engagement',
            userRole: ['user', 'Admin', 'SuperAdmin'],
            // isChild: ['/community-engagement'],
            isVisible:
              validRoute?.findIndex(
                (permission: any) =>
                  permission.moduleName?.toLowerCase() ==
                  'CSR & Community Engagement'.toLowerCase()
              ) > -1 &&
              validRoute[
                validRoute?.findIndex(
                  (permission: any) =>
                    permission.moduleName?.toLowerCase() ==
                    'CSR & Community Engagement'.toLowerCase()
                )
              ].isActive
                ? true
                : false,
          },
          {
            name: 'Employee Details',
            icon: '../../../../assets/images/emp-detail.png',
            icon2: '../../../../assets/images/white-emp-detail.png',
            routerLink: '/social/employee-details',
            isChild: ['/social/employee-info'],
            userRole: ['user', 'Admin', 'SuperAdmin'],
            isVisible:
              validRoute?.findIndex(
                (permission: any) =>
                  permission.moduleName?.toLowerCase() ==
                  'Employee Details'.toLowerCase()
              ) > -1 &&
              validRoute[
                validRoute?.findIndex(
                  (permission: any) =>
                    permission.moduleName?.toLowerCase() ==
                    'Employee Details'.toLowerCase()
                )
              ].isActive
                ? true
                : false,
          },
          {
            name: 'OHS',
            icon: '../../../../assets/images/environment.png',
            icon2: '../../../../assets/images/environment-1.png',
            routerLink: '/social/ohs',
            userRole: ['user', 'Admin', 'SuperAdmin'],
            isChild: ['/social/employee-information'],
            isVisible:
              validRoute?.findIndex(
                (permission: any) =>
                  permission.moduleName?.toLowerCase() == 'OHS'.toLowerCase()
              ) > -1 &&
              validRoute[
                validRoute?.findIndex(
                  (permission: any) =>
                    permission.moduleName?.toLowerCase() == 'OHS'.toLowerCase()
                )
              ].isActive
                ? true
                : false,
          },
          {
            name: 'DEI & HR',
            icon: '../../../../assets/images/DEI & Human Rights-1.png',
            icon2: '../../../../assets/images/DEI & Human Rights.png',
            routerLink: '/social/dei-hr-information',
            userRole: ['user'],
            // isChild: ['/dei-hr-information'],
            isVisible:
              validRoute?.findIndex(
                (permission: any) =>
                  permission.moduleName?.toLowerCase() ==
                  'DEI & Human Rights'.toLowerCase()
              ) > -1 &&
              validRoute[
                validRoute?.findIndex(
                  (permission: any) =>
                    permission.moduleName?.toLowerCase() ==
                    'DEI & Human Rights'.toLowerCase()
                )
              ].isActive
                ? true
                : false,
          },
          {
            name: 'Health & Safety ',
            icon: '../../../../assets/images/Materiality Matrix.png',
            icon2: '../../../../assets/images/Materiality Matrix_white.png',
            routerLink: '/health-safety',
            userRole: ['user', 'Admin', 'SuperAdmin'],
            isVisible: false,
          },
          {
            name: 'Human Right & Labour Practices',
            icon: '../../../../assets/images/Materiality Matrix.png',
            icon2: '../../../../assets/images/Materiality Matrix_white.png',
            routerLink: '/human-right-labour-practices',
            userRole: ['user', 'Admin', 'SuperAdmin'],
            isVisible: false,
          },
          {
            name: 'Training & Development',
            icon: '../../../../assets/images/Materiality Matrix.png',
            icon2: '../../../../assets/images/Materiality Matrix_white.png',
            routerLink: '/social/training-location',
            userRole: ['user', 'Admin', 'SuperAdmin'],
            isVisible:
              validRoute?.findIndex(
                (permission: any) =>
                  permission.moduleName?.toLowerCase() ==
                  'training & development'.toLowerCase()
              ) > -1 &&
              validRoute[
                validRoute?.findIndex(
                  (permission: any) =>
                    permission.moduleName?.toLowerCase() ==
                    'training & development'.toLowerCase()
                )
              ].isActive
                ? true
                : false,
          },
          {
            name: 'Employee Satisfaction & Retention',
            icon: '../../../../assets/images/Materiality Matrix.png',
            icon2: '../../../../assets/images/Materiality Matrix_white.png',
            routerLink: '/social/satisfaction-location',
            isChild: ['/social/satisfaction-location'],
            userRole: ['user', 'Admin', 'SuperAdmin'],
            isVisible:
              validRoute?.findIndex(
                (permission: any) =>
                  permission.moduleName?.toLowerCase() ==
                  'employee satisfaction & retention'.toLowerCase()
              ) > -1 &&
              validRoute[
                validRoute?.findIndex(
                  (permission: any) =>
                    permission.moduleName?.toLowerCase() ==
                    'employee satisfaction & retention'.toLowerCase()
                )
              ].isActive
                ? true
                : false,
          },
          {
            name: 'Customer Health & Safety',
            icon: '../../../../assets/images/Materiality Matrix.png',
            icon2: '../../../../assets/images/Materiality Matrix_white.png',
            routerLink: '/social/customer-health-and-safety',
            isChild: ['/social/product-details-and-company-information'],
            userRole: ['user', 'Admin', 'SuperAdmin'],
            isVisible:
              validRoute?.findIndex(
                (permission: any) =>
                  permission.moduleName?.toLowerCase() ==
                  'Customer Health & Safety'.toLowerCase()
              ) > -1 &&
              validRoute[
                validRoute?.findIndex(
                  (permission: any) =>
                    permission.moduleName?.toLowerCase() ==
                    'Customer Health & Safety'.toLowerCase()
                )
              ].isActive
                ? true
                : false,
          },
        ],
      },
      {
        name: 'Governance',
        icon: '../../../../assets/images/dashboard_icon.png',
        userRole: ['user', 'Admin', 'SuperAdmin'],
        isToggleMenu: true, // Indicates this menu has submenus
        subMenuVisible: false,
        isVisible: true
          ? validRoute?.findIndex((permission: any) =>
              [
                'board structure & financial data',
                'business ethics & anti corruption',
                'data protection & cyber security',
                'stakeholder engagement & political contribution',
              ].includes(permission.moduleName?.toLowerCase())
            ) > -1 &&
            validRoute?.some(
              (permission: any) =>
                [
                  'board structure & financial data',
                  'business ethics & anti corruption',
                  'data protection & cyber security',
                  'stakeholder engagement & political contribution',
                ].includes(permission.moduleName?.toLowerCase()) &&
                permission.isActive === true
            )
          : false,
        subMenu: [
          {
            name: 'Board Structure & Financial Data',
            icon: '../../../../assets/images/Materiality Matrix.png',
            icon2: '../../../../assets/images/Materiality Matrix_white.png',
            routerLink: '/governance/board-location',
            userRole: ['user', 'Admin', 'SuperAdmin'],
            isVisible: true
              ? validRoute?.findIndex(
                  (permission: any) =>
                    permission.moduleName?.toLowerCase() ==
                    'board structure & financial data'.toLowerCase()
                ) > -1 &&
                validRoute[
                  validRoute?.findIndex(
                    (permission: any) =>
                      permission.moduleName?.toLowerCase() ==
                      'board structure & financial data'.toLowerCase()
                  )
                ].isActive
              : false,
          },
          {
            name: 'Business Ethics & Anti Corruption',
            icon: '../../../../assets/images/Materiality Matrix.png',
            icon2: '../../../../assets/images/Materiality Matrix_white.png',
            routerLink: '/governance/ethics-and-anti-corruption',
            userRole: ['user', 'Admin', 'SuperAdmin'],
            isVisible: true
              ? validRoute?.findIndex(
                  (permission: any) =>
                    permission.moduleName?.toLowerCase() ==
                    'business ethics & anti corruption'.toLowerCase()
                ) > -1 &&
                validRoute[
                  validRoute?.findIndex(
                    (permission: any) =>
                      permission.moduleName?.toLowerCase() ==
                      'business ethics & anti corruption'.toLowerCase()
                  )
                ].isActive
              : false,
          },

          {
            name: 'Data Protection & Cyber Security',
            icon: '../../../../assets/images/Materiality Matrix.png',
            icon2: '../../../../assets/images/Materiality Matrix_white.png',
            routerLink: '/governance/data-protection-and-cyber-security',
            userRole: ['user', 'Admin', 'SuperAdmin'],
            isVisible: true
              ? validRoute?.findIndex(
                  (permission: any) =>
                    permission.moduleName?.toLowerCase() ==
                    'Data Protection & Cyber Security'.toLowerCase()
                ) > -1 &&
                validRoute[
                  validRoute?.findIndex(
                    (permission: any) =>
                      permission.moduleName?.toLowerCase() ==
                      'Data Protection & Cyber Security'.toLowerCase()
                  )
                ].isActive
              : false,
          },

          {
            name: 'Risk Assessment & regulatory compliance',
            icon: '../../../../assets/images/Materiality Matrix.png',
            icon2: '../../../../assets/images/Materiality Matrix_white.png',
            routerLink: '/governance/risk-assessment-and-regulatory-compliance',
            userRole: ['user', 'Admin', 'SuperAdmin'],
            isVisible: true
              ? validRoute?.findIndex(
                  (permission: any) =>
                    permission.moduleName?.toLowerCase() ==
                    'Risk Assessment & regulatory compliance'.toLowerCase()
                ) > -1 &&
                validRoute[
                  validRoute?.findIndex(
                    (permission: any) =>
                      permission.moduleName?.toLowerCase() ==
                      'Risk Assessment & regulatory compliance'.toLowerCase()
                  )
                ].isActive
              : false,
          },
          {
            name: 'Stakeholder Engagement & Political Contribution',
            icon: '../../../../assets/images/Materiality Matrix.png',
            icon2: '../../../../assets/images/Materiality Matrix_white.png',
            routerLink:
              '/governance/stakeholder-engagement-and-political-contribution',
            userRole: ['user', 'Admin', 'SuperAdmin'],
            isVisible: true
              ? validRoute?.findIndex(
                  (permission: any) =>
                    permission.moduleName.toLowerCase() ==
                    'Stakeholder Engagement & Political Contribution'.toLowerCase()
                ) > -1 &&
                validRoute[
                  validRoute?.findIndex(
                    (permission: any) =>
                      permission.moduleName.toLowerCase() ==
                      'Stakeholder Engagement & Political Contribution'.toLowerCase()
                  )
                ].isActive
              : false,
          },
        ],
      },
      {
        name: 'Double Materiality Assessment',
        icon: '../../../../assets/images/Materiality Matrix.png',
        icon2: '../../../../assets/images/Materiality Matrix_white.png',
        routerLink: '/materialityAssesment',
        userRole: ['user', 'Admin', 'SuperAdmin'],
        isVisible: true
          ? validRoute?.findIndex(
              (permission: any) =>
                permission.moduleName?.toLowerCase() ==
                'Double Materiality Assessment'.toLowerCase()
            ) > -1 &&
            validRoute[
              validRoute?.findIndex(
                (permission: any) =>
                  permission.moduleName?.toLowerCase() ==
                  'Double Materiality Assessment'.toLowerCase()
              )
            ].isActive
          : false,
      },
      {
        name: 'Supplier Assessment',
        icon: '../../../../assets/images/Supplier Management.png',
        icon2: '../../../../assets/images/Supplier Management_White.png',
        routerLink: '/supplier_assessment',
        userRole: ['user', 'Admin', 'SuperAdmin'],
        isChild: ['/add_supplier', '/edit_supplier/:id'],
        isVisible: true
          ? validRoute?.findIndex(
              (permission: any) =>
                permission.moduleName.toLowerCase() ==
                'Supplier Assessment'.toLowerCase()
            ) > -1 &&
            validRoute[
              validRoute?.findIndex(
                (permission: any) =>
                  permission.moduleName.toLowerCase() ==
                  'Supplier Assessment'.toLowerCase()
              )
            ].isActive
          : false,
      },
      {
        name: 'Benchmarking',
        icon: '../../../../assets/images/Benchmark.png',
        icon2: '../../../../assets/images/Benchmark White.png',
        routerLink: '/benchmarking',
        userRole: ['user', 'Admin', 'SuperAdmin'],
        isVisible: true
          ? validRoute?.findIndex(
              (permission: any) =>
                permission.moduleName?.toLowerCase() ==
                'Benchmarking'.toLowerCase()
            ) > -1 &&
            validRoute[
              validRoute?.findIndex(
                (permission: any) =>
                  permission.moduleName?.toLowerCase() ==
                  'Benchmarking'.toLowerCase()
              )
            ].isActive
          : false,
      },
      {
        name: 'Policy',
        icon: '../../../../assets/images/Policies.png',
        icon2: '../../../../assets/images/Policies_white.png',
        routerLink: '/policies',
        userRole: ['user', 'Admin', 'SuperAdmin'],
        isVisible: true
          ? validRoute?.findIndex(
              (permission: any) =>
                permission.moduleName?.toLowerCase() == 'Policy'.toLowerCase()
            ) > -1 &&
            validRoute[
              validRoute?.findIndex(
                (permission: any) =>
                  permission.moduleName?.toLowerCase() == 'Policy'.toLowerCase()
              )
            ].isActive
          : false,
      },
      {
        name: 'Analysis and Reporting',
        icon: '../../../../assets/images/Reporting & Analysis.png',
        icon2: '../../../../assets/images/Reporting & Analysis_white.png',
        routerLink: '/analysis-reporting',
        userRole: ['user', 'Admin', 'SuperAdmin'],
        isVisible: true
          ? validRoute?.findIndex(
              (permission: any) =>
                permission.moduleName.toLowerCase() ==
                'Analysis and Reporting'.toLowerCase()
            ) > -1 &&
            validRoute[
              validRoute?.findIndex(
                (permission: any) =>
                  permission.moduleName.toLowerCase() ==
                  'Analysis and Reporting'.toLowerCase()
              )
            ].isActive
          : false,
      },
      {
        name: 'CBAM Dashboard',
        icon: '../../../../assets/images/prdct-1.png',
        icon2: '../../../../assets/images/prdct.png',
        routerLink: '/cbam/dashboard',
        userRole: ['user', 'Admin', 'SuperAdmin'],

        isVisible: true
          ? validRoute?.findIndex((permission: any) =>
              ['cbam']?.includes(permission.moduleName.toLowerCase())
            ) > -1 &&
            validRoute[
              validRoute?.findIndex((permission: any) =>
                ['cbam']?.includes(permission.moduleName.toLowerCase())
              )
            ].isActive
          : false,
      },
      {
        name: 'Product Registry',
        icon: '../../../../assets/images/prdct-1.png',
        icon2: '../../../../assets/images/prdct.png',
        routerLink: '/product-registry',
        userRole: ['user', 'Admin', 'SuperAdmin'],
        isVisible: true
          ? validRoute?.findIndex(
              (permission: any) =>
                permission.moduleName.toLowerCase() ==
                'Product Registry'.toLowerCase()
            ) > -1 &&
            validRoute[
              validRoute?.findIndex(
                (permission: any) =>
                  permission.moduleName.toLowerCase() ==
                  'Product Registry'.toLowerCase()
              )
            ].isActive
          : false,
      },
      {
        name: 'CBAM Emission',
        icon: '../../../../assets/images/prdct-1.png',
        icon2: '../../../../assets/images/prdct.png',
        routerLink: '/cbam/emission',
        userRole: ['user', 'Admin', 'SuperAdmin'],
        isVisible: true
          ? validRoute?.findIndex(
              (permission: any) =>
                permission.moduleName.toLowerCase() == 'CBAM'.toLowerCase()
            ) > -1 &&
            validRoute[
              validRoute?.findIndex(
                (permission: any) =>
                  permission.moduleName.toLowerCase() == 'CBAM'.toLowerCase()
              )
            ].isActive
          : false,
      },
    ];
  }
}
